import React from "react"
import PropTypes from "prop-types"
import { StyledButton } from "QuorumGrassroots/styled-components/components/StyledButton"
import { GotvIframe } from "QuorumGrassroots/campaign-forms/components/GotvForm/style"

const GotvForm = (props) => {
    const submit = () =>
        props.postGrassrootsSupporterAction({
            uniqueWidgetId: props.uniqueWidgetId,
            campaign: props.campaign,
            shouldCompleteCampaign: true,
        })

    return (
        <div className="gotv-campaign-main">
            <GotvIframe
                className="gotv-iframe"
                src="https://verify.vote.org/?partner=111111&campaign=free-tools"
                scrolling="yes"
                frameborder="0"
            />
            <StyledButton onClick={submit} disabled={props.isSubmitting} data-cy="sign" isCampaignPage activateNGGTheme>
                {props.styledButtonText}
            </StyledButton>
        </div>
    )
}

GotvForm.propTypes = {
    campaign: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    postGrassrootsSupporterAction: PropTypes.func.isRequired,
    styledButtonText: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    uniqueWidgetId: PropTypes.string.isRequired,
}

export default GotvForm
